import React from "react";

export default function Introduction(props) {
  return (
    <>
      <div className="divider">
        <img alt="logo" src={props.logo} className="logo" />
        <h1 className="header">CHALLENGE DETAILS</h1>
      </div>
      <div>
        <h2 className="introduction">Introduction</h2>
        <p>Thank you for your application to Digital Product School.</p>
        <p>
          This challenge is intended for <strong>{props.track}</strong>{" "}
          applicants.
        </p>
        Their is <strong>no deadline</strong>, but keep in mind that we have
        <strong> limited spots </strong>for each batch. We follow the FIFO
        logic, the applicants who complete the mission first, will be invited
        first for interview. <br />
      </div>
    </>
  );
}
